import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VerificationService, VerificationStatus } from 'app/services/http/verification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CompanyProfileDialogComponent } from '../company-profile-dialog/company-profile-dialog.component';
import { VerificationDialogComponent } from '../verification-dialog/verification-dialog.component';

@Component({
  selector: 'app-card-verification-status',
  templateUrl: './card-verification-status.component.html',
  styleUrls: ['./card-verification-status.component.scss']
})
export class CardVerificationStatusComponent implements OnInit, OnDestroy {

  private _unsubscribeAll = new Subject();

  verificationStatus: VerificationStatus | null = null;
  steps: any = null;
  loading = false;

  constructor(
    private verificationService: VerificationService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadStatus();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  loadStatus(): void {
    this.loading = true;
    this.verificationService.getStatus()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (status) => {
          this.verificationStatus = status;
          this.updateSteps();
          this.loading = false;
        },
        (error) => {
          console.error('Error loading verification status:', error);
          this.loading = false;
          this.snackBar.open('Erro ao carregar status de verificação', 'OK', { duration: 3000 });
        }
      );
  }

  updateSteps(): void {
    if (!this.verificationStatus) return;

    this.steps = {
      email_verified: this.verificationStatus.email_verified,
      phone_verified: this.verificationStatus.phone_verified,
      company_profile_completed: this.verificationStatus.company_profile_completed
    };
  }

  /**
   * Open email/phone verification dialog (reuses the first-access step 3)
   */
  openVerificationDialog(): void {
    const dialogRef = this.dialog.open(VerificationDialogComponent, {
      width: '100%',
      maxWidth: '720px',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadStatus();
    });
  }

  /**
   * Open company profile dialog
   */
  openCompanyProfileDialog(): void {
    if (this.verificationStatus?.company_profile_completed) {
      this.snackBar.open('Dados da empresa já preenchidos', 'OK', { duration: 3000 });
      return;
    }

    const dialogRef = this.dialog.open(CompanyProfileDialogComponent, {
      width: '100%',
      maxWidth: '500px',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadStatus();
      }
    });
  }
}
